<template>
  <b-tabs content-class="mt-3">
    <b-tab title="Benutzer Daten" active>
      <BenutzerBearbeiten :benutzer="benutzer" @updUserToast="emitToast" />
    </b-tab>

    <b-tab title="Benutzer Kontakte">
      <BenutzerKontakteBearbeiten :benutzer="benutzer" @updUserToast="emitToast" />
    </b-tab>
    <b-tab title="Benutzer Geräte">
      <BenutzerGeraeteBearbeiten :benutzer="benutzer" @updUserToast="emitToast" />
    </b-tab>
    <!-- <b-tab title="Benutzer Fotoalben"></b-tab> -->
  </b-tabs>
</template>

<script>
import BenutzerBearbeiten from './BenutzerBearbeiten'
import BenutzerKontakteBearbeiten from './BenutzerKontakteBearbeiten'
import BenutzerGeraeteBearbeiten from './BenutzerGeraeteBearbeiten'

export default {
  name: 'benutzerKontoBearbeiten',
  props: ["benutzer"],
  components: {
    BenutzerBearbeiten,
    BenutzerKontakteBearbeiten,
    BenutzerGeraeteBearbeiten
  },
  methods: {
    emitToast (toastData) {
      this.$emit("updateUserToast", toastData)
    },
  }
}
</script>

<style>

</style>